import requests from '@tools/requests-mixin';

export default {
  mixins: [ requests ],
  methods: {
    formatArrayForGmaps(json) {
      const finaljson = [];
      json.forEach((element) => {
        finaljson.push({ lng: element[0], lat: element[1] });
      });
      return finaljson;
    },
    /**
     * Call to Targomo API
     * @param origins - array of coordinates
     * @param timeValue - max travel time in minutes
     * @param displayPolygons - callback to display polygons
     * @param noPlaceFoundCb - callback if no place is found
     */
    findIdealLocationPolygons(origins, timeValue, displayPolygons, noPlaceFoundCb) {
      // convert mn to seconds for timeValue
      const timeValueSeconds = timeValue * 60;
      const targetSrid = 4326; // @see https://epsg.io/4326
      const buffer = 0.0005; // buffer (in srid units) around polygons
      const simplify = 400; // polygons simplification
      const parameters = {
        edgeWeight: 'time',
        polygon: {
          serializer: 'geojson',
          intersectionMode: 'intersection',
          srid: targetSrid,
          buffer,
          simplify,
          values: [ timeValueSeconds ],
        },
        sources: origins,
      };

      this.post(`https://api.targomo.com/westcentraleurope/v1/polygon?key=${window.targomo_api_key}`, parameters)
        .then((response) => response.data)
        .then((json) => {
          if (json.data.features.length === 0) {
            return noPlaceFoundCb(true, false);
          }
          if (json.data.features[0].geometry.coordinates.length === 0) {
            return noPlaceFoundCb(true, false);
          }
          const polygons = [];

          // Construct the polygon.
          for (let i = 0; i < json.data.features[0].geometry.coordinates.length; i++) {
            let shapeCoordinates = json.data.features[0].geometry.coordinates[i];
            if (json.data.features[0].geometry.type === 'MultiPolygon') {
              [ shapeCoordinates ] = shapeCoordinates;
            }
            polygons.push(shapeCoordinates);
          }
          return displayPolygons(polygons);
        }).catch((error) => noPlaceFoundCb(true, Error(error)));
    },
  },
};
